WebFontConfig = {
    google: { families: ['Varela+Round'] }
};
(function () {
    var wf = document.createElement('script');
    wf.src = ('https:' == document.location.protocol ? 'https' : 'http') +
        '://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
    wf.type = 'text/javascript';
    wf.async = 'true';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(wf, s);
})();

SubscribeToNewsletter = function () {

    emailinput = document.getElementById('subbox');
    var email = $('#subbox').val();
    if (!emailinput.checkValidity() || email === '' || email === null || typeof (email) === 'undefined') {
        $('#newsletterform').show();
        $('#results').html(emailinput.validationMessage);
        return;
    } else {

        var datatosend = "{ email: '" + email + "' }";
        $.ajax({
            type: "POST",
            url: "states/Default2019.aspx/AddMarketingEmailListNewsletter",
            data: datatosend,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (data) {
                resultcode = data.d

                var resulttext = '';
                switch (resultcode) {
                    case 0:
                        $('#newsletterform').show();
                        resulttext = 'Oops, something went wrong! Please try again later!';
                        break;
                    case 1:
                        $('#newsletterform').hide();
                        resulttext = 'Thank you for joining our newsletter.';
                        break;
                    case 2:
                        $('#newsletterform').hide();
                        resulttext = 'Thank you! It looks like you are already part of our newsletter.';
                        break;
                    default:
                        $('#newsletterform').show();
                        resulttext = '';
                }
                if (resultcode == 3) {
                    $('#results').html('Please enter a valid email address.');
                } else {
                    $('#results').html(resulttext);
                }
            }
        });
    }
    return false;

}

$(document).ready(function () {
    var scrollY = parseInt('<%=Request.Form["scrollY"] %>');
    if (!isNaN(scrollY)) {
        window.scrollTo(0, scrollY);
    }
    if (document.location.hash == '#useful-info') {
        setTimeout(function () {
            window.scrollTo(0, $("#useful-info").offset().top - 80);
        }, 1000);
    }
});